'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { WidgetLocationProp } from 'conversations-visitor-experience-components/visitor-widget/constants/WidgetLocations';
import LauncherContainer from '../launcher/container/LauncherContainer';
import InitialMessageBubbleContainer from '../initial-message-bubble/containers/InitialMessageBubbleContainer';
import { AVATAR_SIZES } from 'visitor-ui-component-library/avatar/constants/AvatarSizes';
import { SMALL, MEDIUM } from 'visitor-ui-component-library/constants/sizes';
import { withBrowserSizeContext } from '../containers/withBrowserSizeContext';
import WidgetWindow from './WidgetWindow';
import { FocusScope } from '@react-aria/focus';
import { AccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import QuickReplyGroupOutsideChat from './QuickReplyGroupOutsideChatContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class ApplicationLayout extends Component {
  constructor(props) {
    super(props);
    this.onOpenAnimationStarted = () => {
      this.setState({
        animationsFinished: false,
        shouldRenderDialog: true
      });
    };
    this.onOpenAnimationFinished = () => {
      this.setState({
        animationsFinished: true
      });
    };
    this.onCloseAnimationStarted = () => {
      this.setState({
        animationsFinished: false
      });
    };
    this.onCloseAnimationFinished = () => {
      this.setState({
        animationsFinished: true,
        shouldRenderDialog: false
      });
      this.context.setShouldTrapFocus(false);
    };
    this.getAvatarHeightAboveBubble = this.getAvatarHeightAboveBubble.bind(this);
    this.setInitialMessageRef = this.setInitialMessageRef.bind(this);
    this.setQuickReplyGroupOutsideChatRef = this.setQuickReplyGroupOutsideChatRef.bind(this);
    this.openWidget = this.openWidget.bind(this);
    this.closeWidget = this.closeWidget.bind(this);
    this.state = {
      animationsFinished: true,
      shouldRenderDialog: this.props.isOpen
    };
  }
  getAvatarHeightAboveBubble() {
    const avatarHeightPx = this.props.mobile ? AVATAR_SIZES[SMALL] : AVATAR_SIZES[MEDIUM];
    return avatarHeightPx / 2;
  }
  setInitialMessageRef(element) {
    this.initialMessageRef = findDOMNode(element);
  }
  setQuickReplyGroupOutsideChatRef(element) {
    this.quickReplyGroupRef = findDOMNode(element);
  }
  openWidget() {
    this.setState({
      animationsFinished: false
    });
    this.props.trackUserInteraction();
    this.props.toggleOpen({
      isOpened: true,
      isUser: true
    });
    this.context.setShouldTrapFocus(true);
  }
  closeWidget() {
    this.setState({
      animationsFinished: false
    });
    this.props.trackUserInteraction();
    this.props.toggleOpen({
      isOpened: false,
      isUser: true
    });
  }
  render() {
    const {
      isOpen,
      inline,
      mobile,
      onLauncherHover,
      showInitialMessageBubble,
      widgetLocation
    } = this.props;
    const launcherHidden = isOpen && mobile || inline;
    return /*#__PURE__*/_jsx(AccessibilityContext.Consumer, {
      children: ({
        shouldTrapFocus
      }) => /*#__PURE__*/_jsxs(FocusScope, {
        contain: shouldTrapFocus,
        autoFocus: false,
        children: [/*#__PURE__*/_jsx(WidgetWindow, {
          inline: inline,
          isOpen: isOpen,
          shouldRenderDialog: this.state.shouldRenderDialog,
          mobile: mobile,
          widgetLocation: widgetLocation,
          onOpenAnimationStarted: this.onOpenAnimationStarted,
          onCloseAnimationFinished: this.onCloseAnimationFinished,
          onOpenAnimationFinished: this.onOpenAnimationFinished,
          onCloseAnimationStarted: this.onCloseAnimationStarted,
          onClose: this.closeWidget
        }), showInitialMessageBubble && this.state.animationsFinished && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(InitialMessageBubbleContainer, {
            avatarHeightAboveBubble: this.getAvatarHeightAboveBubble(),
            setInitialMessageRef: this.setInitialMessageRef,
            onClick: this.openWidget,
            widgetLocation: widgetLocation
          }), /*#__PURE__*/_jsx(QuickReplyGroupOutsideChat, {
            setQuickReplyGroupOutsideChatRef: this.setQuickReplyGroupOutsideChatRef,
            widgetLocation: widgetLocation
          })]
        }), !launcherHidden && /*#__PURE__*/_jsx("span", {
          "data-test-id": 'chat-widget-launcher',
          onMouseOver: onLauncherHover,
          children: /*#__PURE__*/_jsx(LauncherContainer, {
            onClose: this.closeWidget,
            onOpen: this.openWidget
          })
        })]
      })
    });
  }
}
ApplicationLayout.displayName = 'ApplicationLayout';
ApplicationLayout.propTypes = {
  inline: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  mobile: PropTypes.bool.isRequired,
  onLauncherHover: PropTypes.func.isRequired,
  showInitialMessageBubble: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  trackUserInteraction: PropTypes.func.isRequired,
  widgetLocation: WidgetLocationProp
};
ApplicationLayout.contextType = AccessibilityContext;
export default withBrowserSizeContext(ApplicationLayout);